import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/api';
import CompanyHeader from '../docs/company_header';
import Watermark from '../components/Watermark';

const Invoice = ({ quoteId }) => {
  const [invoiceRecord, setInvoiceRecord] = useState();
  const [customerInfo,   setCustomerInfo]  = useState();
  const [invoiceData,   setInvoiceData]   = useState([]);

useEffect(() => {
  if (quoteId) {
    //alert(quoteId)
    getInvoiceRecord(quoteId);
    getInvoiceData(quoteId);
  }
}, [quoteId]);

useEffect(() => {
  if (invoiceRecord?.fkCustomerId) {
    getCustomerInfo(invoiceRecord.fkCustomerId);
  }
}, [invoiceRecord]);

  const getInvoiceData = async (quoteId) => {
    try {
      const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
      setInvoiceData(data);
    } catch (err) {
      console.error('Failed to fetch item quotes:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  const getInvoiceRecord = async (quoteId) => {
    try {
      const data = await authFetch(`/quotes/${quoteId}`);
      setInvoiceRecord(data);
    } catch (err) {
      console.error('Failed to fetch quote record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
    const getCustomerInfo = async (customerId) => {
    try {
      const data = await authFetch(`/customers/${customerId}`);
      setCustomerInfo(data);
    } catch (err) {
      console.error('Failed to fetch customer record:', err);
      if (err.message?.includes('401')) {
        // handleLogout(); // Uncomment if logout logic is needed
      }
    }
  };
  // Calculate grand totals
  const totals = invoiceData.reduce(
    (acc, item) => {
      const subtotal = parseFloat(item?.doorData?.calc?.subtotal || 0);
      let discountedSubtotal = parseFloat(item?.doorData?.calc?.discountedSubtotal || subtotal);
      const tax = parseFloat(item?.doorData?.calc?.tax || 0);
      const total = parseFloat(item?.doorData?.calc?.total || 0);

      if (item?.doorData?.discounts?.discount > 0){ 
        discountedSubtotal = subtotal * (1 - item?.doorData?.discounts?.discount / 100);
      }
      if (discountedSubtotal === 0){
        discountedSubtotal = subtotal;
      }

      acc.subtotal += subtotal;
      acc.discountedSubtotal += discountedSubtotal;
      acc.tax += tax;
      acc.total += total;

      return acc;
    },
    { subtotal: 0, discountedSubtotal: 0, tax: 0, total: 0 }
  );

  const customerBoxStyle = {
        border: '1px solid #ccc',
        borderRadius: '15px', // 👈 oval corners
        padding: '1em',
        maxWidth: '300px',
        backgroundColor: '#f9f9f9',
        margin: '1em 0'
};


  return (
    <div className="pdf-capture">
        <CompanyHeader
            documentType="Invoice"
            quoteData={invoiceData[0]?.doorData?.document}
            companyName="Eticom"
        />
        <Watermark show={true} horizontalOffset={500} />
      {customerInfo && (
        <div style={customerBoxStyle}>
          <p><strong>Issued To:</strong> {customerInfo?.fullName}</p>
          <p>{customerInfo?.address1},
          {customerInfo?.city}, {customerInfo?.postalCode},{customerInfo?.province}</p>
          <p>{customerInfo?.mobilePhone}</p>
          <p>{customerInfo?.email}</p>
        </div>
)}
      <p><strong>Quote ID:</strong> {quoteId}</p>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1em' }}>
        <thead>
          <tr>
            <th style={thStyle}>Sub ID</th>
            <th style={thStyle}>Item Type</th>
            <th style={thStyle}>Quantity</th>
            <th style={thStyle}>Subtotal</th>
            
            <th style={thStyle}>After Discount</th>
            
            <th style={thStyle}>Tax</th>
            <th style={thStyle}>Total</th>
          </tr>
        </thead>
        <tbody>
          {invoiceData.map((item) => (
            <tr key={item.id}>
              <td style={tdStyle}>{item.subId}</td>
              <td style={tdStyle}>{item?.doorData?.frameData?.selectedDoor?.name || 'N/A'}</td>
              <td style={tdStyle}>{item?.doorData?.frameData?.quantity || 0}</td>
              <td style={tdStyle}>
                ${parseFloat(item?.doorData?.calc?.subtotal || 0).toFixed(2)}
              </td>
              <td style={tdStyle}>
                ${(
                  item?.doorData?.discounts?.discount > 0
                    ? parseFloat(item?.doorData?.calc?.subtotal || 0) * (1 - item?.doorData?.discounts.discount / 100)
                    : parseFloat(item?.doorData?.calc?.subtotal || 0)
                ).toFixed(2)}
              </td>
              <td style={tdStyle}>
                ${parseFloat(item?.doorData?.calc?.tax || 0).toFixed(2)}
              </td>
              <td style={tdStyle}>
                ${parseFloat(item?.doorData?.calc?.total || 0).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          {/* Spacer row for visual separation */}
          <tr>
            <td colSpan="6" style={{ height: '20px' }}></td>
          </tr>

          {/* Grand total row */}
          <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
            <td colSpan="3" style={tdStyle}>Grand Total:</td>
            <td style={tdStyle}>${totals.subtotal.toFixed(2)}</td>
            
              <td style={tdStyle}>${totals.discountedSubtotal.toFixed(2)}</td>
            
            <td style={tdStyle}>${totals.tax.toFixed(2)}</td>
            <td style={tdStyle}>${totals.total.toFixed(2)}</td>
          </tr>
        </tfoot>

      </table>
    </div>
  );
};

// Simple inline styles
const thStyle = {
  borderBottom: '2px solid #ccc',
  textAlign: 'left',
  padding: '8px',
  backgroundColor: '#f0f0f0'
};

const tdStyle = {
  borderBottom: '1px solid #eee',
  textAlign: 'left',
  padding: '8px'
};

export default Invoice;
